import { render, staticRenderFns } from "./SurveyModal.vue?vue&type=template&id=5224754f&"
import script from "./SurveyModal.vue?vue&type=script&lang=js&"
export * from "./SurveyModal.vue?vue&type=script&lang=js&"
import style0 from "./SurveyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports